import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from '../../store/reducers'
import {loadNpsReducer} from './modules/NetPromotersScoreAnalytics'

export default (store) => ({
  path: 'nps-user-segment',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const LeadDropLeaderAnalytics = require('./containers/NetPromotersScoreAnalytics').default;
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics');
      let homeReducers = require('../Home/modules/home');
      /*  Add the reducer to the store on key 'counter'  */
      const filterValuesReducer = homeReducers.filterValuesReducer;
      injectReducer(store, {key: 'npsUserSegment', reducer: loadNpsReducer});
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer});
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer});
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer});

      cb(null, LeadDropLeaderAnalytics)

      /* Webpack named bundle   */
    }, 'netPromotersScoreAnalytics')
  }
})



// WEBPACK FOOTER //
// ./src/routes/NetPromotersScoreAnalytics/index.js